import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const ImageArticle = (props) => {
    const { content } = props;

    useEffect(() => {
        const extra = content.length % 4 === 0 ? 0 : 4 - content.length % 4;

        for (let i = 0; i < extra; i++) {
            content.push({ isEmpty: true });
        }
    }, [content]);

    const [ isOverflow, setIsOverflow ] = useState(false);

    const cb = useCallback((node) => {
        if (node) {
            const parentHeight = node.offsetHeight;
            let height = 0;
            const children = node.childNodes;

            for (let j = 0; j < children.length; j++) {
                height += children[j].offsetHeight;
            }
            if (parentHeight + 2 < height) {
                setIsOverflow(true);
            }
        }
    }, []);

    return (
        <div className={styles.imageArticle} ref={cb}>
            {
                content.map((item, index) => {
                    return (
                        <div className={`${styles.article} ${item.isEmpty ? styles.empty : ''}`} ref={cb} key={index}>
                            {
                                !item.isEmpty &&
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={formatImage(getThumbnail(item), 244 * 2, 138 * 2)} alt="" />
                                    </div>
                                    <div className={styles.textPart}>
                                        <p className={styles.title}>{item.title}</p>
                                        <hr />
                                        <div className={`${styles.content} ${isOverflow ? styles.overflow : ''}`}>
                                            {item.summary}
                                            <span className={`${styles.more} ${isOverflow ? styles.overflow : ''}`}>[详情]</span>
                                        </div>
                                    </div>
                                </a>
                            }
                        </div>
                    );
                })
            }
        </div>
    );
};

ImageArticle.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(ImageArticle);
